import { ACTION_TYPES } from './Actions';

const initState = {
    filter: {
        markers: []
    }
}

const Reducer = (state = initState, action) => {
    switch (action.type) {
        case ACTION_TYPES.FILTER:
            return {
                ...state,
                filter  : action
            };
        
        default:
            return state;
    }
    
}

export default Reducer;